// Returns a data-qa-selector string for every content type of cards
const getCardDataQaSelector = (props?: {
  label?: string;
  content_type: string;
}) => {
  const mapValues: Record<string, string> = {
    articleheader: "article",
    articlerecommendationexperiment: "article recommendation experiment",
    audiotrack: "audio",
    biography: "biography",
    collection: "collection",
    externallink: props?.label || "external link",
    infographic: "infographic",
    interactivevideolink: "interactive video",
    LEGACY_ARTICLE: "article",
    lessonspark: "lesson spark",
    poll: "poll",
    standard: "standard",
    textset: props?.label || "text set",
    querycontent: "querycontent",
    video: "video",
    worksheet: "worksheet",
  };

  const contentType = props?.content_type?.toLowerCase();

  if (!contentType) {
    return "undefined_card";
  }

  const contentLabel = mapValues[contentType]?.replace(/ /g, "_");

  if (!contentLabel) {
    return "undefined_card";
  }

  return `${contentLabel}_card`.toLowerCase();
};

export default getCardDataQaSelector;
